import { put, call, take, fork } from 'redux-saga/effects'
import { exportCourseTxtService } from '../../api/assignment'
import FileDownload from 'js-file-download'
import { EXPORT_COURSE_TXT } from '../../reducers/assignment/type'
import { exportCourseTxtSuccess } from '../../reducers/assignment/action'

import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* exportCourseTxtFlow(payload) {
  try {
    const { courseId, courseName } = payload

    const response = yield call(exportCourseTxtService, courseId, courseName)

    yield put(exportCourseTxtSuccess())

    FileDownload(response, `Export-${courseName}.txt`)

    yield put(operationSuccess())
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* exportCourseTxtWatcher() {
  while (true) {
    const action = yield take(EXPORT_COURSE_TXT)
    const { payload } = action

    yield fork(generalSaga, exportCourseTxtFlow, payload)
  }
}
